<script>
  import { Link } from "svelte-routing";
  import * as Constants from '../Constants';
  import { _ } from '../services/i18n';

  let navOpen = false;
</script>

<div id="mob-menu-back" class="fadeIn mobile" 
     class:navOpen={navOpen} on:click="{() => navOpen = !navOpen}"></div>

<nav id="menu" class="navbar navbar-default" role="navigation">
  <div class="menu-toggle mobile" on:click="{() => navOpen = !navOpen}">
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </div>
  <ul id="main-menu" class:navOpen={navOpen}>
    <li class="menu-item">
      <Link to="/" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-home" aria-hidden="true"></i><br>
          Home
        </span>
      </Link>
    </li>
    <li class="menu-item" style="display: inline-block;">
      <Link to="/gallery-models" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-cube" aria-hidden="true"></i><br>
          3D Models
        </span>
      </Link>
      <div class="overvocem sprite_world"></div>
      <ul class="toggleMenu toggleMenuWidth">
        <li class="toggleItem">
          <Link to="/gallery-models/buildings" on:click="{() => navOpen = !navOpen}">
          <span class="buildings">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['buildings']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsBuildings')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/characters" on:click="{() => navOpen = !navOpen}">
          <span class="characters">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['characters']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsCharacters')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/weapons" on:click="{() => navOpen = !navOpen}">
          <span class="weapons">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['weapons']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsWeapons')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/animals" on:click="{() => navOpen = !navOpen}">
          <span class="animals">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['animals']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsAnimals')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/objects" on:click="{() => navOpen = !navOpen}">
          <span class="objects">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['objects']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsObjects')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/monsters" on:click="{() => navOpen = !navOpen}">
          <span class="monsters">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['monsters']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsMonsters')}
          </span>
          </Link>
        </li>
        <li class="toggleItem">
          <Link to="/gallery-models/vehicles" on:click="{() => navOpen = !navOpen}">
          <span class="vehicles">
            <i class="fas fa-{Constants.GALLERY_MODELS_TYPES['vehicles']}" aria-hidden="true"></i>
            {$_('menu.sez3dModelsVehicles')}
          </span>
          </Link>
        </li>
      </ul>
    </li>
    <li class="menu-item">
      <Link to="/gallery-websites" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-globe" aria-hidden="true"></i><br>
          Web sites
        </span>
      </Link>
    </li>
    <li class="menu-item">
      <Link to="/gallery-graphics" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-map" aria-hidden="true"></i><br>
          Graphics
        </span>
      </Link>
    </li>
    <li class="menu-item">
      <Link to="/gallery-tools" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-wrench" aria-hidden="true"></i><br>
          Tools
        </span>
      </Link>
    </li>
    <li class="menu-item">
      <Link to="/about" on:click="{() => navOpen = !navOpen}">
        <span class="menu-link sprite_world double-line">
          <i class="fas fa-users" aria-hidden="true"></i><br>
          About
        </span>
      </Link>
    </li>
  </ul>
</nav>

<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$type-lighten: 20%;
$type-lighten-hover: 2%;

#menu {
  float: right;
  display: block;
  width: auto;
  height: 55px;
  margin: 0 30px 0 0;
  padding: 0;
  //text-transform: uppercase;
  font-variant: small-caps;
  font-size: 14px;
  .menu-item {
    list-style-type: none;
    display:block;
    float:left;
    padding:0 1px;
    z-index:10;
    position:relative;
    .toggleMenuWidth, .toggleMenuWidth span {
      width: 114px
    }
    > .toggleMenuWidth {
      margin: 0 -15px
    }
    .toggleMenu {
      position: absolute;
      z-index: 3;
      text-shadow: 1px 1px 1px $idro-palette-black;
      display: none;
      color: #183c7e;
      background: transparentize($idro-palette-highlighted, 0.5);
      @include border-radius(0 0 8px 8px);
      @include box-shadow(0 4px 11px rgba(0, 0, 0, 0.8))
    }
    &:hover .toggleMenu .toggleItem:hover {
      color: #fefeff;
    }
    &:hover .overvocem,
    &:hover .toggleMenu {
      display: block
    }
    .toggleMenu .toggleItem {
      list-style-type: none
    }
    .toggleItem span {
      display: block;
      line-height: 24px;
      font-size: $font-size-base;
      text-align: left;
      font-weight: bolder;
      @include border-radius(9px);
      @include transition(background 0.3s ease-in-out);
      &.buildings {
        color: lighten($idro-gallery-buildings, $type-lighten);
        &:hover { background: lighten($idro-gallery-buildings, $type-lighten-hover); }
      }
      &.characters {
        color: lighten($idro-gallery-characters, $type-lighten);
        &:hover { background: lighten($idro-gallery-characters, $type-lighten-hover); }
      }
      &.weapons {
        color: lighten($idro-gallery-weapons, $type-lighten);
        &:hover { background: lighten($idro-gallery-weapons, $type-lighten-hover); }
      }
      &.animals {
        color: lighten($idro-gallery-animals, $type-lighten);
        &:hover { background: lighten($idro-gallery-animals, $type-lighten-hover); }
      }
      &.objects {
        color: lighten($idro-gallery-objects, $type-lighten);
        &:hover { background: lighten($idro-gallery-objects, $type-lighten-hover); }
      }
      &.monsters {
        color: lighten($idro-gallery-monsters, $type-lighten);
        &:hover { background: lighten($idro-gallery-monsters, $type-lighten-hover); }
      }
      &.vehicles {
        color: lighten($idro-gallery-vehicles, $type-lighten);
        &:hover { background: lighten($idro-gallery-vehicles, $type-lighten-hover); }
      }

      &:hover {
        color: white;
      }
    }
    .fas {
      width: 16px;
      font-size: 12px;
      text-align: center;
      margin-left: 3px;
    }
  }
  .menu-link {
    font-family: $idro-font-family-menu;
    text-shadow: 0 0 4px #000;
    float: left;
    margin: 0 1px;
    z-index: 10;
    position: relative;
    line-height: 80px;
    font-weight: bold;
    width: 82px;
    height: 82px;
    text-align: center;
    background-position: -78px -182px;
    &:hover {
      background-position: -162px -182px
    }
    &.double-line {
      line-height: 14px;
      padding: 27px 0;
      box-sizing: border-box;
    }
    > .fas {
      margin-left: 0;
    }
  }
  .a-link.selected span {
    color: $idro-palette-light-blue;
    background-position: -162px -182px
  }
  .overvocem {
    display: none;
    position: relative;
    height: 23px;
    margin: 64px -16px 0 -16px;
    background-position: -245px -240px;
    z-index: -2
  }
  .dropdown-toggle .icon-bar {
    margin-bottom:2px;
    display: block;
    width: 22px;
    height: 2px;
    background-color: #cccccc;
    @include border-radius(1px);
  }
  &.fixed {
    height:56px;
    margin: 0 30px 0 0;
    .menu-link {
      background-image: none;
      height: auto;
      line-height: 56px;
      &.double-line {
        line-height: 14px;
        padding: 14px 0;
      }
      &:hover {
        background-color: transparentize($idro-palette-second, 0.6);
      }
      &::before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        height: 1px;
        background: #000;
        width: 100%;
        -webkit-transform-origin: right top;
        -moz-transform-origin: right top;
        -ms-transform-origin: right top;
        transform-origin: right top;
        -webkit-transform: scale(0, 1);
        -moz-transform: scale(0, 1);
        -ms-transform: scale(0, 1);
        transform: scale(0, 1);
        -webkit-transition: -webkit-transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
        -moz-transition: -moz-transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transition: transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
    }
    .menu-item {
      &:hover .overvocem {
        display: none;
      }
      > .toggleMenuWidth {
        margin: 56px -15px 0
      }
      .toggleMenu {
        background: transparentize($idro-palette-highlighted, 0.14);
        @include border-radius(8px);
        @include box-shadow(3px 4px 11px rgba(0, 0, 0, 0.8))
      }
    }
  }
}
span.menu-link:hover {
  animation: vocemRotation 1s 1 ease;
}
@keyframes vocemRotation {from{transform:rotateX(20deg)}to{transform:rotateX(0deg)}}

/** LITTLE PC */
@media #{$tablet} {
  /** Menu */
  #menu {
    margin: 0 30px 0 0;
    .menu-toggle {
      width: 30px;
      margin: 28px 0 0 0;
      float: right;
      cursor: pointer;
      .icon-bar {
        margin-bottom: 8px;
        display: block;
        width: 30px;
        height: 4px;
        background-color: $idro-menu;
        border-radius: 2px;
      }
    }
    &.fixed .menu-toggle {
      margin: 14px 0 0 0;
    }
    #main-menu {
      display: none;
      margin: 0;
      padding: 0 0 0 2px;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 600;
      background-color: rgba(15, 54, 68, .75);
      box-shadow: -10px 10px 15px 5px rgba(0,0,0,.4);
      resize: vertical;
      overflow-y: scroll;
      overflow-x: auto;
      height: 100%;
      width: auto;
      &.navOpen {
        display: block;
      }
      .menu-link {
        border: 2px solid #15363a;
        width: 200px;
        height: 34px;
        line-height: 34px;
        background: #2c707b;
        @include border-radius(10px);
        margin: 0;
        &.double-line {
          padding: 5px 0;
          line-height: 14px;
          height: 40px;
          margin: 0 2px;
        }
      }
      .menu-item {
        float: none;
        z-index: 100;
        &:hover .overvocem{display:none}
        > span {
          display: block;
          height: 38px;
        }
        .toggleMenu {
          position: inherit;
          display: block !important;
          width: 100%;
          background: none;
          margin: 0;
          box-shadow: none
        }
        .toggleItem {
          width: 95%;
          background: #274f58;
          margin: 7px 5px;
          @include border-radius(9px);
        }
      }
      .toggleItem span {
        width: 100%;
        text-align: center;
      }
      .toggleItemIcons {
        background: none;
        width: 0;
        height: 0;
      }
    }
  }
  #mob-menu-back {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    margin: 0;
    z-index: 99;
    position: fixed;
    top: 0;
    bottom: 0;
    background: none rgba(17,54,68,0.60);
    &.navOpen {
      display: block;
    }
  }
}

/** PC SMALL */
@media #{$tablet-s} {
  #menu {
    margin: 0 10px 0 0;
    &.fixed {
      margin: 0 15px 0 0;
      .menu-toggle {
        margin: 10px 0 0 0;
      }
    }
    .menu-toggle {
      width: 15px;
      margin: 25px 0 0 6px;
      .icon-bar {
        width: 8px;
        margin-bottom: 6px;
        height: 8px;
        background-color: #acb1b6;
        border-radius: 4px;
      }
    }
  }
}

/** PC SMALL */
@media #{$tablet-xs} {
  #header {
    height: 86px;
  }
  #backgrounds-toggle {
    margin-top: 15px;
    margin-right: 12px;
  }
  #search-toggle {
    margin-top: 15px;
  }
  #menu .menu-toggle {
    margin-top: 12px;
  }
  #search-container {
    top: 86px;
  }
}

/** MOBILE */
@media #{$mobile} {
  #mob-menu-back {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    margin: 0;
    z-index: 99;
    position: fixed;
    top: 0;
    bottom: 0;
    background: none rgba(17,54,68,0.60);
    &.navOpen {
      display: block;
    }
  }
  .menu-toggle {
    width: 50px;
    margin: 25px 40px 0 0;
    float: right;
    cursor: pointer;
    .icon-bar {
      margin-bottom: 8px;
      display: block;
      width: 30px;
      height: 4px;
      background-color: $idro-menu;
      border-radius: 2px;
    }
  }
  #menu {
    margin: 0 20px 0 0;
    &.fixed {
      display: block;
    }
    #main-menu {
      display: none;
      margin: 0;
      padding: 0 0 0 2px;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 600;
      background-color: rgba(15,54,68,0.75);
      box-shadow: -10px 0 36px 5px rgba(0,0,0,.4);
      resize: vertical;
      overflow: scroll;
      height: 100%;
      width: auto;
      &.navOpen {
        display: block;
      }
      .menu-link {
        border: 2px solid #15363a;
        margin: 0;
        //width: 352px;
        height: 80px;
        line-height: 80px;
        background: #2c707b;
        @include border-radius(25px);
      }
      .menu-item {
        float: none;
        z-index: 100;
        &:hover .overvocem { display:none; }
        > span {
          display: block;
          height: 38px;
        }
        .toggleMenu {
          position: inherit;
          display: block !important;
          width: 100%;
          background: none;
          margin: 0;
          box-shadow: none;
        }
        .toggleItem {
          width: 95%;
          background: #274f58;
          @include border-radius( 20px );
          .a-link {
            line-height: 30px;
            width: 100%;
            text-align: center;
          }
        }
      }
      #menu-tools.menu-item .toggleMenu { display: none !important; }
      .toggleItemIcons { background: none; width: 0; height: 0; }
    }
  }
  #mob-menu-back {
    display: none;
    width: 100%;
    height: 100%;
    margin: 0; z-index: 99;
    position: fixed;
    top: 0;
    bottom: 0;
    background: none rgba(17,54,68,0.60);
  }
}

/** MOBILE MEDIUM */
@media #{$mobile-m} {
  #menu.fixed {
    margin: 0 10px 0 0;
    .menu-toggle {
      margin: 10px 8px 0 0;
      width: 15px;
      .icon-bar {
        width: 8px;
        margin-bottom: 6px;
        height: 8px;
        background-color: #acb1b6;
        border-radius: 4px;
      }
    }
  }
}

@media #{$mobile-s} {
  #menu {
    margin: 0 10px 0 0;
  }
}
</style>
